"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
/*
 * Copyright (c) 2024 MTa VELA. All Rights Reserved.
 *
 * MTa VELA proprietary information: the enclosed materials contain proprietary information of MTa VELA and shall not be
 * disclosed in whole or in any part to any third party or used by any person for any purpose, without written consent
 * of MTa VELA. Duplication of any portion of these materials shall include this notice.
 */
/**
 * Enum representing the possible statuses of an order.
 */
var OrderStatus;
(function (OrderStatus) {
    /**
     * The order is in draft state. The customer is still working on it and hasn't submitted it yet.
     */
    OrderStatus["Draft"] = "Draft";
    /**
     * The customer has confirmed and submitted the order for processing.
     * For invoice payments, this indicates that the customer has requested an invoice.
     */
    OrderStatus["Submitted"] = "Submitted";
    /**
     * The order is awaiting payment. For invoice payments, this indicates that an invoice
     * has been sent to the customer, and we're waiting for them to complete the payment.
     */
    OrderStatus["AwaitingPayment"] = "AwaitingPayment";
    /**
     * The payment for the order has been received and verified.
     */
    OrderStatus["Paid"] = "Paid";
    /**
     * The order has been completely processed and delivered (especially relevant for physical goods).
     */
    OrderStatus["Fulfilled"] = "Fulfilled";
    /**
     * The order has been cancelled. This might occur if an invoice isn't paid within a certain timeframe.
     */
    OrderStatus["Cancelled"] = "Cancelled";
    /**
     * The order has been refunded.
     */
    OrderStatus["Refunded"] = "Refunded";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
